module.exports = __webpack_public_path__ + "media/theme/sample__dmm--sp-79d9413b.png";